import React from 'react';
import { connect } from 'react-redux';

import { saveView, showSaveView } from 'Store/reducers/SharedViewsReducer';
import StandardList from '../Lists/StandardList';
import T from '../../Helpers/translate';
import Bem from '@upsales/components/Utils/bemClass';
import { Title, Button } from '@upsales/components';

import './StandardView.scss';

const mapStateToProps = state => ({
	standardList: state.SharedViews.list,
	sharedList: state.SharedViews.sharedList,
	privateList: state.SharedViews.privateList,
	groupedList: state.SharedViews.groupedList,
	selectedView: state.SharedViews.selectedView
});

const mapDispatchToProps = {
	saveView,
	showSaveView
};

function StandardView({
	privateList,
	sharedList,
	standardList,
	groupedList,
	changeView,
	isChangingView,
	showSaveView
}) {
	const StandardClass = new Bem('StandardView');
	const listArray = [];

	if (privateList.length) {
		listArray.push([
			<Title key="private-list-title" className={StandardClass.elem('Title').b()}>
				{T('sharedViews.myViews')}
			</Title>,
			<StandardList
				key="private-standard-list"
				listType="private"
				list={privateList}
				changeView={changeView}
				disableChangeView={isChangingView}
			/>
		]);
	}

	if (sharedList.length) {
		listArray.push([
			<Title
				key="shared-views-title"
				className={StandardClass.elem('Title').mod({ Secondary: privateList.length }).b()}
			>
				{T('sharedViews.sharedViews')}
			</Title>,
			<StandardList
				key="shared-views-list"
				listType="shared"
				list={sharedList}
				changeView={changeView}
				disableChangeView={isChangingView}
			/>
		]);
	}

	listArray.push([
		<Title key="standard-views-title" className={StandardClass.elem('Title').mod('Secondary').b()}>
			{T('sharedViews.standardViews')}
		</Title>,
		<StandardList
			key="standard-views-list"
			changeView={changeView}
			listType="standard"
			list={standardList}
			removeDefault={true}
			disableChangeView={isChangingView}
		/>
	]);

	if (groupedList) {
		Object.keys(groupedList).forEach(group => {
			listArray.push([
				<Title key={`${group}-title`} className={StandardClass.elem('Title').mod('Secondary').b()}>
					{T(group)}
				</Title>,
				<StandardList
					key={`${group}-list`}
					changeView={changeView}
					listType="standard"
					list={groupedList[group]}
					removeDefault={true}
					disableChangeView={isChangingView}
				/>
			]);
		});
	}

	return (
		<div className={StandardClass.b()}>
			<Button
				className={StandardClass.elem('SaveAs').b()}
				type="link"
				onClick={() => {
					showSaveView({ createNew: true });
				}}
			>
				{T('filters.saveViewAs')}
			</Button>
			{_.flatten(listArray)}
		</div>
	);
}

export const detached = StandardView;
export default connect(mapStateToProps, mapDispatchToProps)(StandardView);
